/**
 * SearchSuggestion Component
 *
 * Individual search suggestion item for Hero Search dropdown
 * Figma: Search Suggestion (Node: 595:4670, 595:4674)
 *
 * Dimensions:
 * - Height: 50.75px
 * - Full width, flex layout with space-between
 *
 * Typography (exact Figma specs):
 * - Font: Inter, Medium (500)
 * - Size: 14px
 * - Line height: 22.75px
 * - Letter spacing: -0.1504px
 * - Color: #0a0a0a (neutral-950)
 *
 * Variants:
 * - Default: Text only
 * - With Arrow: Text + arrow icon (for "Explore Brands")
 *
 * Arrow Icon: 12.25×12.25px
 */
"use client";

import Image from "next/image";

interface SearchSuggestionProps {
  text: string;
  onClick: () => void;
  showArrow?: boolean;
}

export function SearchSuggestion({ text, onClick, showArrow = false }: SearchSuggestionProps) {
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center justify-between transition-opacity hover:opacity-70"
      style={{
        height: "50.75px",
      }}
    >
      {/* Suggestion Label - Figma Node: I595:4670;595:4742 */}
      <div className="flex items-center justify-center">
        <p
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "22.75px",
            letterSpacing: "-0.1504px",
            color: "#0a0a0a", // neutral-950 (Text/Paragraph 2* - Soft Black)
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </p>
      </div>

      {/* Diagonal Arrow Icon - only for Explore Brands (Figma Node: I595:4674;595:4738) */}
      {showArrow && (
        <div
          className="flex-shrink-0"
          style={{
            width: "12.25px",
            height: "12.25px",
          }}
        >
          <Image src="/icons/arrow-white.svg" alt="" width={12.25} height={12.25} />
        </div>
      )}
    </button>
  );
}
